export default "__VITE_ASSET__C$B4vTXn__"